import { render, staticRenderFns } from "./applyDiscounts.vue?vue&type=template&id=0765b2b0&"
import script from "./applyDiscounts.vue?vue&type=script&lang=js&"
export * from "./applyDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./applyDiscounts.vue?vue&type=style&index=0&id=0765b2b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports